module.exports = __webpack_public_path__ + "img/document_docsign.7c95f84d.png";